import React, { useContext, useState } from 'react';
import { DateTimeUtils, Table, NotificationType, ClippedContent, VoicemailPlayback } from 'dyl-components';
import Contact from 'shared/Contact';
import { Link } from 'react-router-dom';
import { Icon, Checkbox, Grid, Popup, Dropdown, Loader } from 'semantic-ui-react';
import { BulkActionsContext } from 'shared/context/BulkActionsProvider';
import { StringUtils } from 'utils';

import '../index.scss';
import { useSelector } from 'react-redux';

export const NotificationsRow = ({  notification, onOpenNotification, tab, onToggleSnoozeModal, snoozedOptions, remove, archive, markRead, snooze, readSchedule, isReadingSchedule, onMarkVoicemailListened }) => {
    const notification_details = notification.notification_details;
    const type = notification.notification_type;
    const url = notification_details?.url;
    const isDescription = (type !== "fax" && type !== "missed_call");
    const loggedInUserName = useSelector(state => state.auth.name);

    const [isVoicemailPlaybackOpen, setIsVoicemailPlaybackOpen] = useState(false);
    const [selectedNotifications, setSelectedNotifications] = useContext(BulkActionsContext);
    const notificationType = (() => {
        if (type === "task") {
            return `${StringUtils.capitalize(notification_details.task_type)} Task `;
        }
        if (type === "missed_call") {
            return "Missed Call";
        }
        if (type === "assigned_record") {
            return "Assigned";
        }
        return StringUtils.capitalize(type);
    })();
    const { snoozed: isSnoozed, read: isRead, archived: isArchived, notification_id: notificationId } = notification;
    const snoozeDateTimeFormat = `${DateTimeUtils.formatEpoch(notification.notification_ts, DateTimeUtils.WORD_DATE_FORMAT)} at ${DateTimeUtils.formatEpoch(notification.notification_ts, DateTimeUtils.TIME_FORMAT)}`;
    const contactId = notification_details?.contact_id;
    const accountId = notification_details?.account_id;
    const userId = notification_details?.user_id;
    const cnam = notification_details?.cnam_name;

    const isSelected = (notification_id) => {
        return selectedNotifications.includes(notification_id);
    }

    const onToggleContact = (notification_id) => {
        const newSelectedNotifications = isSelected(notification_id) ? selectedNotifications.filter(id => notification_id !== id) : [...selectedNotifications, notification_id];
        setSelectedNotifications(newSelectedNotifications);
    }

    const onOpenMarkReadNotification = () =>{
        onOpenNotification(notification.external_id, type, notificationId);
        !isRead && markRead(notificationId, true);
    }
    const getDescription = () => {
        if (type === "voicemail") {
            return `VM Box ${notification_details?.voicemail}`;
        }
        if (type === "text") {
            return notification_details?.message;
        }
        return notification_details?.description;
    }
    return (
        <Table.Row>
            <Table.Cell>
                <Checkbox checked={isSelected(notificationId)} onChange={() => { onToggleContact(notificationId) }} />
            </Table.Cell>
            <Table.Cell >
                <div><b>{DateTimeUtils.getDay(notification.notification_ts) === "Today" ? "Today" : DateTimeUtils.formatEpoch(notification.notification_ts, DateTimeUtils.WORD_DATE_FORMAT)}</b></div>
                <div>{DateTimeUtils.formatEpoch(notification.notification_ts, DateTimeUtils.TIME_FORMAT)}</div>
            </Table.Cell>
            <Table.Cell>
                {(!contactId && !accountId) &&
                    cnam
                }
                {((notification_details?.contact_name || notification_details?.account_name) && (contactId || accountId)) &&
                    <Contact
                        contact={{
                            id: contactId ? contactId : accountId,
                            phone: {
                                phone: notification_details?.contact?.phone,
                                call_suspended: notification_details?.contact?.call_suspended
                            },
                            email: { id: notification_details?.contact?.email },
                            contact_name: contactId ? notification_details?.contact_name : notification_details.account_name,
                            archived: contactId ? notification_details?.contact?.archived : notification_details?.account?.archived
                        }}
                        name={contactId ? notification_details?.contact_name : notification_details.account_name}
                        linkToContact={<Link to={`/${contactId ? "contact" : "account"}/${contactId ? contactId : accountId}`}>{contactId ? notification_details?.contact_name : notification_details?.account_name}</Link>} 
                        account={accountId && notification_details?.account_type}
                        displayIcon
                    />
                }
                {notification_details?.user_name && userId && (
                    <Contact
                        contact={{id: userId, contact_name: notification_details.user_name, email: {id:true}, archived: notification_details?.user?.archived  }}
                        name={notification_details?.user_name}
                        linkToContact={<Link to={`/settings/users/${userId}/general`}>{notification_details.user_name}</Link>}
                        hideId
                        isSimplified
                    />
                )}
                {notification_details && type === 'assigned_record' && (
                    <Contact
                        contact={{
                            id: Number(contactId ? contactId : accountId),
                            phone: {
                                phone: notification_details?.contact?.phone,
                                call_suspended: notification_details?.contact?.call_suspended
                            },
                            email: { id: notification_details?.contact?.email },
                            contact_name: notification_details.name,
                            archived: contactId ? notification_details?.contact?.archived : notification_details?.account?.archived
                        }}
                        name={notification_details.name}
                        linkToContact={<Link to={`/${notification_details.contact_type}/${contactId ? contactId : accountId}`}>{notification_details.name}</Link>}
                        account={accountId && notification_details?.account_type}
                        displayIcon
                    />
                )}
                {notification_details && type === 'text' && (() => {
                    const link = (() => {
                        const root = contactId ? `contact/${contactId}/texts` : `account/${accountId}/texts`;
                        const queryParams = new URLSearchParams();
                        if (notification_details.to) {
                            queryParams.set("from", notification_details.to.replace(/^\+?1/, ""));
                        }
                        if (notification_details.contact?.phone) {
                            queryParams.set("to", notification_details.contact?.phone);
                        }
                        return `/${root}?${queryParams.toString()}`;
                    })()
                    return (
                        <Contact
                            contact={{
                                id: Number(contactId ? contactId : accountId),
                                phone: {
                                    phone: notification_details?.contact?.phone,
                                    call_suspended: notification_details?.contact?.call_suspended
                                },
                                email: { id: notification_details?.contact?.email },
                                contact_name: notification_details.name,
                                archived: contactId ? notification_details?.contact?.archived : notification_details?.account?.archived
                            }}
                            name={notification_details.name}
                            linkToContact={<Link to={link}>{notification_details.name}</Link>}
                            account={accountId && notification_details?.account_type}
                            displayIcon />
                    );
                })()}
                {notification_details && type === 'campaign' && (
                    <Contact
                        contact={{id: userId, contact_name: loggedInUserName, email: {id:true}  }}
                        name={loggedInUserName}
                        linkToContact={<Link to={`/settings/users/${userId}/general`}>{loggedInUserName}</Link>}
                        hideId
                        isSimplified
                    />
                )}
            </Table.Cell>
            <Table.Cell>
                <Grid columns='equal'>
                    <Grid.Column width='5'>
                        <NotificationType name={userId && type !== "voicemail" && type !== "campaign" ? "user_missed_call" : type} /> 
                    </Grid.Column>
                    <Grid.Column verticalAlign='middle' style={{paddingLeft: 0}}>
                        {notificationType}
                    </Grid.Column>
                </Grid>
            </Table.Cell>
            <Table.Cell style={{maxWidth:200}}>
                {notification_details?.title && <a href role="button" onClick={()=> onOpenMarkReadNotification()} ><b style={{marginRight: 7, cursor: 'pointer'}}>{notification_details?.title}</b></a>}
                {isDescription &&
                    <ClippedContent position="bottom center">
                        {getDescription()}
                    </ClippedContent> 
                }
            </Table.Cell>
            <Table.Cell width={1}>
                <div className='Notification__actions'>
                    {tab !== "snoozed" &&
                        <>
                            {isRead ? 
                                <Popup
                                    trigger={
                                        <Icon className="fa-solid fa-circle-dashed" onClick={() => markRead(notificationId, false)} />
                                    }
                                    content={ "Mark as unread"}
                                    position="top center"
                                    inverted
                                />  
                            :
                                <Popup
                                    trigger={
                                        <Icon className="fa-solid fa-circle" onClick={() => markRead(notificationId, true)} />
                                    }
                                    content={ "Mark as read"}
                                    position="top center"
                                    inverted
                                />
                            }
                        </>
                    }
                    {type === "voicemail" &&
                        
                        <Popup
                            style={{minWidth:300}}
                            trigger={
                                <Icon className='fa-solid fa-circle-caret-right audio-button' disabled={!!!url} />                            
                            }
                            on="click"
                            content={
                                <VoicemailPlayback
                                    onClose={() => setIsVoicemailPlaybackOpen(false)}
                                    className={`audio-playback-${notificationId}`}
                                    fileName="Voicemail"
                                    link={url}
                                    isVoicemail
                                    onMarkAsListened={() =>
                                        onMarkVoicemailListened(
                                            notification?.external_id?.split?.(
                                                "_"
                                            )?.[1]
                                        )
                                    }
                                />
                            }
                            position="bottom center"
                            open={isVoicemailPlaybackOpen}
                            onOpen={() => setIsVoicemailPlaybackOpen(true)}
                        />
                    }
                    {tab !== "archived"  &&
                        <Dropdown
                            icon={false}
                            text={
                                <Popup
                                    trigger={<Icon

                                        className="fa-solid fa-alarm-snooze"
                                    />}
                                    inverted
                                    content={isSnoozed ? `Snoozed: ${snoozeDateTimeFormat}` :"Snooze"}
                                    position="top center"
                                />
                            }
                            onOpen={() => readSchedule()} 
                        >
                            <Dropdown.Menu style={{left: -150}}> 
                                <Dropdown.Header as='h3' content='Snooze until...' style={{textTransform: "unset", fontSize: "unset", marginBottom: isSnoozed ? 0 : 14}}/>
                                { isReadingSchedule ?
                                    <Loader active inline='centered' />
                                :
                                    <>
                                        {isSnoozed && <Dropdown.Header content={snoozeDateTimeFormat} style={{fontStyle: "italic", textTransform: "unset", fontSize: "unset", fontWeight: 500, marginTop: 0}}/> }
                                        {snoozedOptions.map(({ text, ts }, id) => {
                                            return (
                                                <Dropdown.Item
                                                    key={id}
                                                    children={
                                                        <Grid columns='equal'>
                                                            <Grid.Column>
                                                                {text}
                                                            </Grid.Column>
                                                            <Grid.Column textAlign='right'>
                                                                <b>{StringUtils.toUpperCase(DateTimeUtils.formatEpoch(ts, DateTimeUtils.WORD_DAY_FORMAT))}</b>
                                                            </Grid.Column>
                                                            <Grid.Column>
                                                                {DateTimeUtils.formatEpoch(ts)}
                                                            </Grid.Column>
                                                        </Grid>
                                                    }
                                                    style={{ cursor: 'pointer' }}
                                                    onClick={() => snooze(notificationId, ts)}
                                                />
                                            );
                                        })}
                                        <Dropdown.Divider />
                                        <Dropdown.Item
                                            key='5'
                                            children={<><Icon className="fas fa-calendar" />Pick date and time</>}
                                            style={{ cursor: 'pointer' }}
                                            onClick={() => onToggleSnoozeModal(notificationId)}
                                        />
                                    </>
                                }
                            </Dropdown.Menu>
                        </Dropdown>
                    }
                    <Popup
                        trigger={
                            <Icon className="fa-solid fa-box-archive" onClick={() => archive(notificationId, !isArchived)} /> 
                        }
                        content={isArchived ? "Unarchive" : "Archive"}
                        position="top center"
                        inverted
                    />
                    {tab === "archived" && 
                        <Popup
                            trigger={
                                <Icon className="trash" onClick={() => remove(notificationId)} />
                            }
                            content={"Delete"}
                            position="top center"
                            inverted
                        />
                    }
                </div>
            </Table.Cell>
        </Table.Row>
    );
}


